



































































import {Vue, Component} from 'vue-property-decorator';
import {SHOPBY_ACCESSTOKEN} from '@/const/words/cookie';
import { Sticker} from 'supporter';
import {getCookie} from '@/utils/cookieUtils';
const accessToken = getCookie(SHOPBY_ACCESSTOKEN);
@Component({components: {}})
export default class ProductStickerAddForm extends Vue {
  private mallNo = 0;
  private callback = '';
  private sticker: Sticker = {
    displayOrder: 0,
    stickerNo: 0,
    stickerType: 'TEXT',
    content: ''
  };
  created() {
    this.mallNo = Number(this.$route.params.mallNo);
    this.callback = this.$route.query.callback as string;
    if (this.$route.params.hasOwnProperty('stickerNo')) {
      const params : any = {
        mallNo: this.mallNo,
        stickerNo: Number(this.$route.params.stickerNo)
      };
      this.$api.getSticker({params}).then((res) => {
        this.sticker = res.data;
        this.$forceUpdate();
      });
    }
  }
  private addFile() {
    const file = Array.from((this.$refs.image as HTMLInputElement).files as FileList)[0];
    if (file) {
      this.uploadFile(file, (data: any) => {
        this.sticker.content = data.url;
      });
    }
  }
  removeContent() {
    this.sticker.content = '';
  }
  private uploadFile(file: any, callback: Function): void {
    if (!file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp)$/)) {
      alert(this.$t('PRODUCT_STICKER_ALERT3'));
      return;
    }
    if (file.size > 10240) {
      alert(this.$t('PRODUCT_STICKER_ALERT'));
      return;
    }
    const data = new FormData();
    data.append('file', file);
    this.$api.postImages({data, params: {mallNo: Number(this.mallNo)}}).then((res) => {
      callback(res.data);
    });
    // axios({
    //   headers: {
    //     Version: '1.0',
    //     'Content-Type': 'multipart/form-data',
    //     accessToken
    //   },
    //   data,
    //   method: 'post',
    //   url: `${process.env.VUE_APP_API_URL}/images?mallNo=${this.mallNo}`
    // }).then((request: any) => {
    //   callback(request.data);
    // });
  }
  save() {
    if (!this.sticker.content) {
      alert(this.$t('PRODUCT_STICKER_ALERT2'));
      return;
    }
    if (this.sticker.stickerNo) {
      if (confirm(this.$t('PRODUCT_STICKER_CONFIRM') as string)) {
        alert(this.$t('PRODUCT_STICKER_ALERT_SAVE'));
        $(window.opener.location).attr('href', `javascript:window.${this.callback}(${JSON.stringify(this.sticker)});`);
        window.close();
      }
    } else {
      alert(this.$t('PRODUCT_STICKER_ALERT_SAVE'));
      $(window.opener.location).attr('href', `javascript:window.${this.callback}(${JSON.stringify(this.sticker)});`);
      window.close();
    }
  }
  close() {
    window.close();
  }
  onStickerTypeChanged() {
    this.sticker.content = '';
  }
}
